import { DTMF_COMMANDS } from './command-map';

export function addDTMFCommandPrefix(command: string) {
    return `${DTMF_COMMANDS.commandList.open}${command}`;
}
